import { render, staticRenderFns } from "./VxCalendarInput.vue?vue&type=template&id=56db8243&scoped=true"
import script from "./VxCalendarInput.vue?vue&type=script&lang=js"
export * from "./VxCalendarInput.vue?vue&type=script&lang=js"
import style0 from "./VxCalendarInput.vue?vue&type=style&index=0&id=56db8243&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56db8243",
  null
  
)

export default component.exports